import { ProjectJourneyUpdateDTO } from 'models/dto/projects/projectJourneyDTO';
import { ProjectJourneyUpdate } from 'models/projects/projectJourney';

// Journey update mappers - GET projects/{id}/journey/update.

export function mapFromProjectJourneyUpdate(dto: ProjectJourneyUpdateDTO): ProjectJourneyUpdate {
  const update = new ProjectJourneyUpdate();
  update.packageVersion = dto.packageVersion ?? '';
  update.packageDescription = dto.packageDescription ?? '';
  update.isNewerVersion = dto.isNewerVersion ?? false;

  return update;
}
